// 自定义过滤器
import Vue from 'vue';
import moment from 'moment';
import cosFilters from './cos';

Object.keys(cosFilters).forEach(k => Vue.filter(k, cosFilters[k]));

/**
 * 格式化时间戳
 */
Vue.filter('FormatDate', (timestamp, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (typeof timestamp === 'string') {
    return timestamp;
  }
  if (Number.isNaN(timestamp)) {
    return '-';
  }
  return moment(new Date(timestamp)).format(format);
});

Vue.filter('DateStr', (timestamp, format = 'YYYY-MM-DD HH:mm:ss') => moment(new Date(timestamp)).format(format));

/**
 * 格式化文件图标
 */
const mapping = {
  jpg: 'jpg,png,jpeg,gif,ico,bmp,svg,psd,tif',
  doc: 'doc,docx,wps,wpt,dot,dotx,docm,dotm,rtf,mht',
  mp3: 'mp3,cda,wav,wma,rma,mid,midi,ogg,aac,flac,ape,aiff,au,mod,xmi,rmi,cd',
  mp4: 'mp4,rmvb,mtv,mov,vcd,dat,mpeg,mpg,avi,rm,ra,asf,wmv,flv,swf,3gp,amv,dmv',
  pdf: 'pdf,xps',
  ppt: 'ppt,pptx,dps,dpt,pps,pot,pptm,potx,potm,ppsm,ppsx',
  txt: 'txt,html,yml,xhtml,htm,php,js,css,vue,md',
  xls: 'xls,xls,xlt,xltm,xlsm,et,ett,csv',
  zip: 'zip,rar,gz,tar,iso,dmg,7z,bz,bz2,cab',
  other: '',
};
const icon = {};
Object.keys(mapping).forEach(key => {
  mapping[key].split(',').forEach(ext => {
    if (ext) {
      icon[ext] = key;
    }
  });
});
Vue.filter('FileIcon', (filename, isDir) => {
  if (isDir) {
    return 'document';
  }
  const index = filename.lastIndexOf('.');
  const ext = index > -1 ? filename.substr(index + 1) : '';
  return icon[ext.toLowerCase()] || 'other';
});

/**
 * 格式化大小
 */
Vue.filter('formatSize', size => {
  if (typeof size === 'string') {
    return size;
  }
  if (Number.isNaN(size)) {
    return 0;
  }

  let sizeRes = parseFloat(size);
  const unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
  if (!Number.isFinite(sizeRes)) {
    return 0 + unit[0];
  }
  let index = 0;
  for (; index < unit.length && sizeRes >= 1024; index += 1) {
    sizeRes /= 1024;
  }
  return Math.round(sizeRes * 100) / 100 + unit[index];
});

/**
 * 翻译错误提示
 */
Vue.filter('TranslateExtractError', err => {
  const { code } = err;
  let msg = '';
  switch (code) {
    case 'NoSuchSid': {
      msg = window.lang.t('core.NoSuchSid');
      break;
    }
    case 'ExpiredUrl': {
      msg = window.lang.t('core.ExpiredUrl');
      break;
    }
    case 'ErrorExtractCode': {
      msg = window.lang.t('core.ErrorExtractCode');
      break;
    }
    case 'GetAccessCodeWrong': {
      msg = window.lang.t('core.GetAccessCodeWrong');
      break;
    }
    default: {
      msg = window.lang.t('core.PleaseEnterCode');
      break;
    }
  }
  return msg;
});

/**
 * 翻译错误提示
 */
Vue.filter('TranslateTableErrorShow', code => {
  let msg = '';
  switch (code) {
    case 'NoSuchSid': {
      msg = window.lang.t('core.NoSuchSid');
      break;
    }
    case 'ExpiredUrl': {
      msg = window.lang.t('core.ExpiredUrl');
      break;
    }
    default: {
      msg = window.lang.t('core.InternetError');
      break;
    }
  }
  return msg;
});

/**
 * 翻译提取码错误提示
 */
Vue.filter('TranslateExtractErrorCode', code => {
  let msg = '';
  switch (code) {
    case 'NoSuchSid': {
      msg = window.lang.t('core.NoSuchSid');
      break;
    }
    case 'ExpiredUrl': {
      msg = window.lang.t('core.ExpiredUrl');
      break;
    }
    case 'ErrorExtractCode': {
      msg = window.lang.t('core.ErrorExtractCode');
      break;
    }
    case 'GetAccessCodeWrong': {
      msg = window.lang.t('core.GetAccessCodeWrong');
      break;
    }
    default: {
      msg = window.lang.t('core.PleaseEnterCode');
      break;
    }
  }
  return msg;
});
